import React from "react";
import store from "./redux/store";
import "./styles.css";
import { createRoot } from "react-dom/client";
import "./fonts/BoschSans-Bold.ttf";
import "./fonts/BoschSans-Medium.ttf";
import "./fonts/BoschSans-Regular.ttf";
import "./fonts/BoschSans-Light.ttf";
import UserService from "./utils/UserService";

import App from "./App";

const publicRoutes = ["/unauthorize", "/login", "/sessao-expirada"];

const currentPath = window.location.pathname;

const renderApp = () =>
  createRoot(document.getElementById("root")).render(<App store={store} />);

if (publicRoutes.includes(currentPath)) {
  renderApp();
} else {
  UserService.initKeycloak(renderApp);
}
